import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { getAllPriceSchemes } from 'src/api/getAllPriceSchemes/getAllPriceSchemes';
import { QueryKeys } from '../QueryKeys';
import { getBrandId } from 'src/helpers/getBrandId/getBrandId';
import { IPriceScheme, PriceSchemeStatus } from '../../types/price.types';

const staleTime = 5 * 60 * 1000; // 5 minutes

export const usePriceSchemes = (options?: UseQueryOptions<IPriceScheme[]> & { refetchOnCreating?: boolean }) => {
  const { refetchOnCreating = true, ...queryOptions } = options || {};
  const brandId = getBrandId();

  return useQuery<IPriceScheme[]>({
    queryKey: [QueryKeys.priceSchemes, brandId],
    queryFn: getAllPriceSchemes,
    staleTime,
    refetchInterval: (priceSchemes: IPriceScheme[]): number | false => {
      const isCreating = priceSchemes?.some((scheme) => scheme.status === PriceSchemeStatus.CREATING);
      return isCreating && refetchOnCreating ? 5 * 1000 : false;
    },
    ...queryOptions,
    enabled: !!brandId && (queryOptions.enabled ?? true),
  });
};
